import strings from '../../Localization/Localization';

import { store } from '../../Store/configureStore';

import {
  technicalTicket as technicalTicketRoutes,
  commercialTicket as commercialTicketRoutes,
  administrativeTicket as administrativeTicketRoutes,
  installationTicket as installationTicketRoutes,
  terminationTicket as terminationTicketRoutes
} from '../Route/routes';

let yousignStatus = {
  fieldKey: "status",
  type: "dropdown",
  label: strings.form.appointment.yousignStatus.label,
  showOnDisabled: (getValues, getExtraValues) => {
    let credentials = getExtraValues().credentials();
    return credentials.roles.includes('ROLE_NYUKOM') && typeof getValues()["yousign_signature_request"] === 'object' && getValues()["yousign_signature_request"]["id"]
  },
  validators: [],

  input: 'options',
  showEmpty: true,
  options: [
    {
      value: 'ongoing',
      label: strings.form.appointment.yousignStatus.options.ongoing
    },
    {
      value: 'done',
      label: strings.form.appointment.yousignStatus.options.done
    },
    {
      value: 'declined',
      label: strings.form.appointment.yousignStatus.options.declined
    },
    {
      value: 'expired',
      label: strings.form.appointment.yousignStatus.options.expired
    },
    {
      value: 'deleted',
      label: strings.form.appointment.yousignStatus.options.deleted
    },
  ],
}

let yousignLink = (type) => {
  let path = null;
  switch (type) {
    case 'technical':
      path = (id) => technicalTicketRoutes.routes.yousign.createPath(id);
      break;
    case 'commercial':
      path = (id) => commercialTicketRoutes.routes.yousign.createPath(id);
      break;
    case 'administrative':
      path = (id) => administrativeTicketRoutes.routes.yousign.createPath(id);
      break;
    case 'installation':
      path = (id) => installationTicketRoutes.routes.yousign.createPath(id);
      break;
    case 'termination':
      path = (id) => terminationTicketRoutes.routes.yousign.createPath(id);
      break;
    default:
  }

  if(!path) {
    return;
  }

  return {
    fieldKey: "yousign_link",
    type: "button",
    label: strings.form.appointment.yousignLink.label,
    showOnDisabled: (getValues) => typeof getValues()["yousign_signature_request"] === 'object' && getValues()["yousign_signature_request"]["id"] && getValues()["yousign_signature_request"]["status"] === "ongoing",
    validators: [],

    as: 'a',
    path: (getValues, getExtraValues) => path(getValues()["id"])
  }
}

export const form = (type) => {
  return {
    formKey: "appointmentSignatureRequest",
    fields: [
      yousignStatus,
      yousignLink(type)
    ],
    extraValues: {
      credentials: () => store.getState().persisted.credentials
    }
  }
}
